<button
  (click)="clickButton.emit($event)"
  class="icon {{ icon }} text-{{ color }}-{{ intensity }} bg-transparent rounded-full"
></button>
